<app-navbar-style-two></app-navbar-style-two>

<section class="blog-wrapper">

    <div class="container">

        <!-- Blog Header -->
        <div class="blog-header">

            <h1>{{ blogData.title }}</h1>

            <div class="blog-meta">
                <span>
                    <i class='bx bx-calendar'></i>
                    {{ blogData.created_date | date:'dd MMM yyyy' }}
                </span>

                <span>
                    <i class='bx bx-user'></i>
                    Kitchen Magic
                </span>
            </div>

        </div>

        <!-- Featured Image -->
        <div class="blog-banner">

            <img
                [src]="blogData.image"
                [alt]="blogData.title">

        </div>

        <!-- Article Content -->
        <div class="blog-content">

            <div
                [innerHTML]="blogData.description">
            </div>

        </div>

        <!-- Quote Box -->
        <div class="quote-box">

            <h2>
                Design is not just what it looks like and feels like.
                Design is how it works.
            </h2>

        </div>

        <!-- CTA Section -->
        <div class="cta-section">

            <h3>
                Ready to Transform Your Kitchen?
            </h3>

            <p>
                Explore innovative kitchen designs and renovation
                solutions tailored to your lifestyle.
            </p>

            <a routerLink="/contact" class="cta-btn">
                Contact Us
            </a>

        </div>

        <!-- Author -->
        <div class="author-box">

            <div class="author-info">

                <h4>Kitchen Magic Team</h4>

                <p>
                    Sharing kitchen design inspiration,
                    renovation ideas and practical home solutions.
                </p>

            </div>

        </div>

    </div>

</section>

 